import { FEATURE_FLAGS } from '../../constants/general';
import { useFeature } from '../features/features.hooks';

export const useIsLuxuryTheme = () => useFeature(FEATURE_FLAGS.LUXURY_REBRAND, { isSiteWide: true });

export const useIsLuxuryTypography = () => useFeature(FEATURE_FLAGS.LUXURY_TYPOGRAPHY, { isSiteWide: true });

export const useIsLuxuryHeader = () => useFeature(FEATURE_FLAGS.LUXURY_HEADER, { isSiteWide: true });
